import { vyDate } from '@vy/utils';
import { saveAs } from 'file-saver';

import type { UseLatestEventsPayload } from '../../../../hooks/requests/use-latest-events/use-latest-events-types';
import { runMutation } from '../../../../utils/vy-mutation';
import { generateEventsCSV } from '../events-page-utils/events-page-generate-csv';
import { useNonPagedEventsFromParams } from './use-non-paged-events-from-params';

type UseEventsActionsProps = {
  filterInfo: Omit<UseLatestEventsPayload, 'page' | 'pageSize'>;
};

export const useEventsActions = ({ filterInfo }: UseEventsActionsProps) => {
  const allEventsMutation = useNonPagedEventsFromParams(filterInfo);

  const handleExportEvents = async () => {
    const allEventsResponse = await runMutation(allEventsMutation, undefined, {
      pending: 'Downloading all events...',
      success: 'All events downloaded',
      error: 'Failed to download all events',
    });

    if (!allEventsResponse) {
      return;
    }

    const events = allEventsResponse.events ?? [];
    const csvContent = generateEventsCSV(events);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });

    const fileName = vyDate().format('MMMM, DD, YYYY');
    saveAs(blob, `${fileName}.csv`);
  };

  return {
    handleExportEvents,
    isExporting: allEventsMutation.isLoading,
  };
};
